var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#002FA7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3550_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1621 19.5945C12.1621 18.1038 13.4414 16.8918 15.015 16.8918H26.4264C27.9999 16.8918 29.2792 18.1038 29.2792 19.5945V30.4054C29.2792 31.8961 27.9999 33.1081 26.4264 33.1081H15.015C13.4414 33.1081 12.1621 31.8961 12.1621 30.4054V19.5945ZM37.0845 18.4037C37.548 18.6402 37.8378 19.0962 37.8378 19.5945V30.4054C37.8378 30.9037 37.548 31.3598 37.0845 31.5962C36.6209 31.8327 36.0592 31.8074 35.6179 31.5287L31.3386 28.826L30.7057 28.4248V27.7027V22.2973V21.5751L31.3386 21.1739L35.6179 18.4712C36.0548 18.1967 36.6164 18.1672 37.0845 18.4037V18.4037Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3550_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6757,
    height: 18.9189,
    fill: "white",
    transform: "translate(12.1621 15.5405)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/scheduleIcon.57188cd271ea0b4be6bf27a7e6aace8f.svg";
export { ForwardRef as ReactComponent };